import { useAuthenticator } from "@aws-amplify/ui-react";
import { Box, Divider, Paper, Typography } from "@mui/material";
import { useNavigate } from "react-router-dom";
import { getDateForView, getFormattedDate } from "./utility/getFormattedDate";
import { useEffect, useState } from "react";
import { getCapitalizationListById } from "./utility/getCapitalizationListById";
import { baseWhite } from "./utility/colorPalette";
import { useAuth } from "../context/AuthContext";

interface capitalizationDataType {
  userId: string;
  conversationId: string;
  date: string;
  complete: boolean;
  threadId?: string;
}

export const HistoryPage = () => {
  const navigate = useNavigate();
  const { user } = useAuthenticator((context) => [context.user]);
  const { idToken, refreshAuthSession } = useAuth();
  const todaysDate: string = getFormattedDate();

  const [conversationList, setConversationList] = useState<
    capitalizationDataType[]
  >([]);

  const [newCapitalizationButtonViewIsOn, setNewCapitalizationButtonViewIsOn] =
    useState<boolean>(false);

  // 最初の会話データ0の表示用
  const [isNoDate, setIsNoData] = useState<boolean>(false);

  useEffect(() => {
    if (idToken) {
      getCapitalizationListById(user.userId, idToken).then((data) => {
        //   console.log(data);
        setConversationList(data);

        if (data.length === 0) {
          setIsNoData(true);
        }

        // 会話一覧の中に本日のデータが無い場合のみ新しい会話を開始できるようにする
        const isTodaysConversationData = data.some(
          (capitalization: capitalizationDataType) =>
            capitalization.date === todaysDate
        );
        if (!isTodaysConversationData) {
          setNewCapitalizationButtonViewIsOn(true);
        }
      });
    }
  }, []);

  // 過去の会話へ飛ぶ
  const viewPastCapitalization = (
    capitalizationData: capitalizationDataType
  ) => {
    // とりあえず仮仕様として、過去の日付の場合はcomplete扱いとする。
    // EventBridgeでcompleteにした方がちゃんとしている気はする。
    const completeState: boolean =
      capitalizationData.date !== todaysDate
        ? true
        : capitalizationData.complete;

    navigate("/chat", {
      state: {
        conversationId: capitalizationData.conversationId,
        conversationDate: capitalizationData.date,
        complete: completeState,
        threadId: capitalizationData.threadId,
      },
    });
  };

  return (
    <Box sx={{ m: 3 }}>
      {/* <Typography>開発用のためチャット詳細が見れるようにしています</Typography> */}
      <Typography>あなたの実施日</Typography>

      <Paper
        elevation={10}
        sx={{ mt: 2, py: 2, px: 2, backgroundColor: "white", borderRadius: 4 }}
      >
        {conversationList.length > 0 && (
          <Box>
            {conversationList.map((capitalizationData, index) => (
              <Box
                key={capitalizationData.conversationId}
                // onClick={() => viewPastCapitalization(capitalizationData)}
                sx={{}}
              >
                <Typography variant="body1" sx={{ my: 1 }}>
                  {getDateForView(capitalizationData.date)}
                </Typography>
                {index !== conversationList.length - 1 && <Divider />}
              </Box>
            ))}
          </Box>
        )}
        {isNoDate && (
          <Box sx={{ padding: "2rem" }}>
            <Typography>データはまだありません</Typography>
          </Box>
        )}
      </Paper>
    </Box>
  );
};
